import { render, staticRenderFns } from "./LegacyCartTable.vue?vue&type=template&id=62f2b993"
import script from "./LegacyCartTable.vue?vue&type=script&lang=js"
export * from "./LegacyCartTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports